import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {get, post} from 'bukku/shared/ApiService';
import AppActions from '../App/actions';

// Read
export function* readRequest() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_REQUEST, function* ({ id, cs, ct, emails }) {
        try {
            const response = yield call(get, `/public/transactions/${id}`, {
                cs,
                ct,
                emails,
            });
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_SUCCESS,
                transaction: data.transaction,
                company: data.company,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_ERROR,
                error,
            });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_ERROR, function* ({ error }) {
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403)
            yield message.error(error.message);
    });
}

// Read V2
export function* readV2Request() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V2_REQUEST, function* ({
        id, subdomain, transactionEmailId, formDesignId,
    }) {
        try {
            const request = {
                subdomain,
                transaction_email_id: transactionEmailId,
                form_design_id: formDesignId,
            };

            const response = yield call(get, `/v2/public/transactions/${id}`, request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_V2_SUCCESS,
                transaction: data.transaction,
                company: data.company,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_V2_ERROR,
                error,
            });
        }
    });
}
export function* readV2Success() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V2_SUCCESS, () => {});
}
export function* readV2Error() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V2_ERROR, function* ({ error }) {
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403)
            yield message.error(error.message);
    });
}

// Read V3 (with myInvois features)
export function* readV3Request() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V3_REQUEST, function* (
        { hash, subdomain, transactionEmailId, formDesignId },
    ) {
        try {
            const request = {
                subdomain,
                transaction_email_id: transactionEmailId,
                form_design_id: formDesignId,
            };

            const response = yield call(get, `/public/transactions/${hash}`, request);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_V3_SUCCESS,
                transaction: data.transaction,
                company: data.company,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_V3_ERROR,
                error,
            });
        }
    });
}
export function* readV3Success() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V3_SUCCESS, () => {});
}
export function* readV3Error() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_V3_ERROR, function* ({ error }) {
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403)
            yield message.error(error.message);
    });
}

export function* readFileRequest() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_FILE_REQUEST, function* ({ fileId }, context) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            const response = yield call(get, `/files/${fileId}`, null, context);
            const data = yield response.data;

            //OK
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_FILE_SUCCESS,
                file: data.file,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_TRANSACTION_READ_FILE_ERROR,
                error,
            });
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});
        }
    });
}

export function* readFileSuccess() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_FILE_SUCCESS, () => {});
}

export function* readFileError() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_READ_FILE_ERROR, function* ({error}) {
        yield message.error(error.message);
    });
}

export function* createPayexPaymentRequest() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_REQUEST,
        function* (request, context) {
            try {
                const response = yield call(
                    post, '/payex/invoice_payments', request.request, context,
                );

                if (request.openInNewTab)
                    yield window.open(`${response.data.url}`, "_blank");
                else
                    yield window.open(`${response.data.url}`, "_self");

                //OK
                yield put({
                    type: actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_SUCCESS,
                });
            }
            catch (error) {
                yield put({
                    type: actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_ERROR,
                    error,
                });
            }
        });
}

export function* createPayexPaymentSuccess() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_SUCCESS, () => {});
}

export function* createPayexPaymentError() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_CREATE_PAYEX_PAYMENT_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* requestEInvoiceRequest() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_REQUEST,
        function* ({request, hash, subdomain}, context) {
            try {
                request.is_public = true;
                yield put({ type: AppActions.APP_START_PUSHING });
                yield call(
                    post, `/public/transactions/${hash}/validate?subdomain=${subdomain}`, request, context,
                );

                //OK
                yield put({
                    type: actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_SUCCESS,
                });
            }
            catch (error) {
                yield put({
                    type: actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_ERROR,
                    error,
                });
            }
            finally {
                yield put({ type: AppActions.APP_STOP_PUSHING });
            }
        });
}

export function* requestEInvoiceSuccess() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_SUCCESS, () => {});
}

export function* requestEInvoiceError() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REQUEST_E_INVOICE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export function* rejectEInvoiceRequest() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_REQUEST,
        function* ({request, hash, subdomain}, context) {
            try {
                request.is_public = true;
                yield put({ type: AppActions.APP_START_PUSHING });
                yield call(
                    post, `/public/transactions/${hash}/reject?subdomain=${subdomain}`, request, context,
                );

                //OK
                yield put({
                    type: actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_SUCCESS,
                });
            }
            catch (error) {
                yield put({
                    type: actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_ERROR,
                    error,
                });
            }
            finally {
                yield put({ type: AppActions.APP_STOP_PUSHING });
            }
        });
}

export function* rejectEInvoiceSuccess() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_SUCCESS, () => {});
}

export function* rejectEInvoiceError() {
    yield takeEvery(actions.PUBLIC_TRANSACTION_REJECT_E_INVOICE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(readV2Request),
        fork(readV2Success),
        fork(readV2Error),
        fork(readV3Request),
        fork(readV3Success),
        fork(readV3Error),
        fork(readFileRequest),
        fork(readFileSuccess),
        fork(readFileError),
        fork(createPayexPaymentRequest),
        fork(createPayexPaymentSuccess),
        fork(createPayexPaymentError),

        fork(requestEInvoiceRequest),
        fork(requestEInvoiceSuccess),
        fork(requestEInvoiceError),

        fork(rejectEInvoiceRequest),
        fork(rejectEInvoiceSuccess),
        fork(rejectEInvoiceError),
    ]);
}
